import CityPageTemplate from "../city-template/CityPageTemplate";
import { fountainConfig } from "./data";

export default function FountainPage() {
  return <CityPageTemplate config={fountainConfig} />;
}